/* eslint-disable react/destructuring-assignment,react/prop-types */
// Copyright (c) 2019 Deere & Company

import './common-modal.scss';
import Modal from 'react-bootstrap/Modal';
import React from 'react';

const CommonModal = (props) => (
    <div className="modal-base">
        <Modal
            dialogClassName={props.className}
            keyboard
            onHide={props.onClose}
            show={props.isOpen}
            size={props.size}
            centered
        >
            { props.header && (
                <Modal.Header>
                    <span className="modal-header-label">
                        {' '}
                        {props.title}
                    </span>
                    <span
                        className="icon-close"
                        onClick={props.onClose}
                    />
                </Modal.Header>
            )}
            <Modal.Body>{props.children}</Modal.Body>
            {props.footer && (
                <Modal.Footer>
                    {props.footercontent}
                </Modal.Footer>
            )}
        </Modal>
    </div>
);

CommonModal.defaultProps = {
    className: 'jd-warranty-modal',
    size: 'lg',
};
export default CommonModal;
